import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getTenant } from '@ovpn-ui-toolkit/mf-common';
import {
    selectIsMember,
    selectIsLoggedIn,
    notificationRoutines,
    notificationSelectors,
    NotificationPortalType,
} from '@cloud/shared';

function useNotification() {
    const dispatch = useDispatch();
    const notification = useSelector(notificationSelectors.selectNotification);

    const isLoggedIn = useSelector(selectIsLoggedIn);
    const isMember = useSelector(selectIsMember);

    const isCloudPortal = getTenant() === 'cloud';

    const portal = isMember
        ? NotificationPortalType.UserPortal
        : NotificationPortalType.OwnerPortal;

    useEffect(() => {
        if (isLoggedIn && !isCloudPortal) {
            dispatch(notificationRoutines.loadNotifications(portal as any /** FixMe */));
        }
    }, [dispatch, isLoggedIn, isCloudPortal, portal]);

    return notification;
}

export default useNotification;
